import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
const RTL_LANGS = new Set(['ar', 'ur']);
export function RTLProvider({ children }) {
    const { i18n } = useTranslation();
    useEffect(() => {
        const dir = RTL_LANGS.has(i18n.language) ? 'rtl' : 'ltr';
        document.documentElement.lang = i18n.language;
        document.documentElement.dir = dir;
    }, [i18n.language]);
    return _jsx(_Fragment, { children: children });
}
